import { render, staticRenderFns } from "./reader.vue?vue&type=template&id=5926526a&scoped=true&"
import script from "./reader.vue?vue&type=script&lang=js&"
export * from "./reader.vue?vue&type=script&lang=js&"
import style0 from "./reader.vue?vue&type=style&index=0&id=5926526a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5926526a",
  null
  
)

export default component.exports